import type { BadgeProps } from "~/components/ui";

import type { DipCountTone, DipTone } from "~/features/dataImportProjects/types";

/** Maps a DipTone to the shadcn Badge `tone` variant. */
export const badgeToneFor: Record<DipTone, NonNullable<BadgeProps["tone"]>> = {
  neutral: "default",
  success: "score-a",
  attention: "score-b",
  error: "score-c",
  primary: "primary",
  accent: "status-draft",
};

/** Count-badge circle classes per tone. */
export const countToneClass: Record<DipCountTone, string> = {
  neutral: "border-border-strong bg-bg-subtle text-fg-3",
  success: "border-score-a bg-score-a-bg text-score-a",
  attention: "border-score-b bg-score-b-bg text-[#B25612]",
  error: "border-score-c bg-score-c-bg text-score-c",
  primary: "border-primary-300 bg-primary-50 text-primary-700",
  accent: "border-[#C9B8E4] bg-status-draft-bg text-[#5E3884]",
  white: "border-border-strong bg-bg-surface text-fg-2",
  primaryFilled: "border-[#7CB7E8] bg-[#DCEEFB] text-[#1B4F86]",
  primaryOutline: "border-[#7CB7E8] bg-bg-surface text-[#1B4F86]",
};

/** Small colored square classes per tone. */
export const squareToneClass: Record<DipTone, string> = {
  neutral: "bg-fg-3",
  success: "bg-score-a",
  attention: "bg-score-b",
  error: "bg-score-c",
  primary: "bg-primary-500",
  accent: "bg-status-draft",
};
